let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bVcRO")).then(() => parcelRequire('6Je3Y'));